import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

type AppInsightsPlugin = Pick<ReactPlugin, 'trackException'>;
type AppInsights = ApplicationInsights;

const getAppInsights = () => {
  const reactPlugin = new ReactPlugin();
  const appInsights: AppInsights = new ApplicationInsights({
    config: {
      instrumentationKey: process.env.REACT_APP_APP_INSIGHTS_KEY,
      extensions: [reactPlugin],
    },
  });

  return { appInsights, reactPlugin };
};

const appInsightsFactory = (
  getAppInsightsPlugin: () => { appInsights: AppInsights; reactPlugin: AppInsightsPlugin }
): AppInsightsPlugin => {
  const { appInsights, reactPlugin } = getAppInsightsPlugin();
  appInsights.loadAppInsights();

  return reactPlugin;
};

export const appInsightsPlugin: AppInsightsPlugin = appInsightsFactory(getAppInsights);
